import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
export { default } from "./Stripe";

export const typeGuard = (system: PaymentSystemPublic | null): boolean => {
  return system?.type === "stripe" ?? false;
};
